import styled from 'styled-components';

import {Icon} from '@thenewboston/ui';

export const NewWindowIcon = styled(Icon)`
  display: inline-flex;
  margin-left: 1px;
  margin-right: 3px;
`;
